// @flow

import React, { Component } from 'react';
import '../../src/App.css';

type Props = {
  question?: string,
  onClick?: () => void,
  small?: boolean
};

type State = {};

class Box extends Component<Props, State> {
  render() {
    const { onClick, small } = this.props;

    return (
      <div onClick={onClick} className={'box ' + (small ? 'box--small' : '')}>
        <p>{this.props.question}</p>
      </div>
    );
  }
}

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.js